export default {
  'pages.cart.title': '购物车',
  'pages.cart.table.header.info': '商品信息',
  'pages.cart.table.header.values': '定制工艺',
  'pages.cart.table.header.color': '配件颜色',
  'pages.cart.table.header.quantity': '数量',
  'pages.cart.table.header.action': '操作',
  'pages.cart.table.checkAll': '全选',
  'pages.cart.table.delete': '删除',
  'pages.cart.table.total': '商品总计：',
  'pages.cart.table.unit.single': '件',
  'pages.cart.table.unit.plural': '件',
  'pages.cart.table.btn.submit': '提交意向单',
  'pages.cart.table.deleteTip.single': '您确定移除该商品吗？',
  'pages.cart.table.deleteTip.plural': '您确定移除这些商品吗？',
  'pages.cart.submit.success.title': '温馨提示',
  'pages.cart.submit.success.content': '您已成功提交意向单！',
  'pages.cart.submit.success.okBtn': '联系客服',
  'pages.cart.submit.success.cancelBtn': '查看意向单',
  'pages.cart.submit.error.title': '温馨提示',
  'pages.cart.submit.error.content': '加入意向单异常请联系在线客服！',
  'pages.cart.submit.error.okBtn': '在线客服',
};
